import BackToTopContainer from './BackToTop.container';
import BackToTop from './BackToTop';
export default BackToTopContainer(BackToTop);
export { default as SimpleBackToTop } from './SimpleBackToTop';
//# sourceMappingURL=index.js.map